import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  JSON: { input: any; output: any };
  JSONObject: { input: Record<string, any>; output: Record<string, any> };
  Upload: { input: File; output: File };
};

/** Accept invite response with redirect */
export type AcceptInviteMutationResponse = {
  redirect?: Maybe<RedirectType>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Billing account */
export type Account = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  assessments?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSONObject"]["output"]>;
  dimensions?: Maybe<Array<Maybe<Scalars["JSONObject"]["output"]>>>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_owner?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  positions?: Maybe<Scalars["Boolean"]["output"]>;
  projects?: Maybe<Scalars["Boolean"]["output"]>;
  /** This is field is deprecated and always returns null */
  subscription?: Maybe<AccountSubscriptionDetails>;
  teams?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Contact details for the user who gets billed */
export type AccountBillingUser = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type AccountSubscriptionDetails = {
  allowedProfiles?: Maybe<Scalars["Int"]["output"]>;
  billingUser?: Maybe<AccountBillingUser>;
  isOwner?: Maybe<Scalars["String"]["output"]>;
  seatsUsed?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Survey */
export type ActiveSurvey = {
  blocks_count?: Maybe<Scalars["Int"]["output"]>;
  complete?: Maybe<Scalars["Boolean"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  duration?: Maybe<Scalars["String"]["output"]>;
  hasIntro?: Maybe<Scalars["Boolean"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  main_text?: Maybe<Scalars["String"]["output"]>;
  rows_count?: Maybe<Scalars["Int"]["output"]>;
  survey_rows?: Maybe<Array<Maybe<SurveyRowLoaded>>>;
  text_tid?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  ui_template?: Maybe<Scalars["String"]["output"]>;
};

export type AddPersonInput = {
  account_access_level?: InputMaybe<WorkspaceAccessLevel>;
  account_role?: InputMaybe<WorkspaceRoles>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  linkedin_data?: InputMaybe<Scalars["JSON"]["input"]>;
  organization?: InputMaybe<OrganizationRelationInput>;
  project?: InputMaybe<ProjectRelationObjectInput>;
  send_invite?: InputMaybe<InviteInput>;
  team?: InputMaybe<TeamRelationObjectInput>;
};

export type Assessment = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person?: Maybe<Person>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard?: Maybe<Scorecard>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentEvaluation = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  evaluation?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
};

export type AssessmentNote = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Person>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type AssessmentOrder = {
  assessment_link?: Maybe<Scalars["String"]["output"]>;
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  completed_at?: Maybe<Scalars["String"]["output"]>;
  created_at?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  redirect_url?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<Survey>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentRowDimensionInput = {
  dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  target_max?: InputMaybe<Scalars["Int"]["input"]>;
  target_min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type AssessmentSurvey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
};

export type AssessmentSurveyAnswerInput = {
  answer: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

export type AssessmentSurveyRow = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  block_id?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type Attachment = {
  content_type?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  file_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  isEmbedded?: Maybe<Scalars["Boolean"]["output"]>;
  tags?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type AttachmentsFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A dimension text */
export type DimText = {
  /** low, mid, high */
  bucket?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  /** The priority of the text in the bucket. Default is 1. */
  display_order?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Deprecated in favor of bucket. Will be removed in future releases. */
  value?: Maybe<Scalars["Int"]["output"]>;
};

/** A dimension */
export type Dimension = {
  code?: Maybe<Scalars["String"]["output"]>;
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  group?: Maybe<Scalars["String"]["output"]>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  parent?: Maybe<Scalars["String"]["output"]>;
  parent_id?: Maybe<Scalars["Int"]["output"]>;
  parent_title?: Maybe<Scalars["String"]["output"]>;
  scores?: Maybe<Array<Maybe<Score>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** The dimension object */
export type DimensionLoaded = {
  answer?: Maybe<SurveyAnswerObject>;
  behaviours?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  description_neg?: Maybe<Scalars["String"]["output"]>;
  description_pos?: Maybe<Scalars["String"]["output"]>;
  description_short?: Maybe<Scalars["String"]["output"]>;
  description_tid?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  name_neg?: Maybe<Scalars["String"]["output"]>;
  name_pos?: Maybe<Scalars["String"]["output"]>;
  question_left?: Maybe<Scalars["String"]["output"]>;
  question_opposite_tid?: Maybe<Scalars["String"]["output"]>;
  question_right?: Maybe<Scalars["String"]["output"]>;
  question_tid?: Maybe<Scalars["String"]["output"]>;
};

export type DimensionsFilter = {
  group?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  people?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  personal?: InputMaybe<Scalars["Boolean"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InviteInput = {
  org_id: Scalars["Int"]["input"];
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Mutation response with message and mutated object ids. */
export type MutationResponse = {
  /** The list on ids of the mutated objects. This is available for CRUD mutations for bulk and single operations. For agregated utility mutations this will be empty. */
  ids?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  message?: Maybe<Scalars["String"]["output"]>;
  success?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A note */
export type Note = {
  assessment_id?: Maybe<Scalars["Int"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type NotesFilter = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Notification type */
export type Notification = {
  id?: Maybe<Scalars["Int"]["output"]>;
  message?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type OrganizationRelationInput = {
  access_level?: InputMaybe<OrganizationAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<OrganizationRoles>;
};

export type OrganizationRoles = "ADMIN" | "CANDIDATE" | "MEMBER";

export type OrganizationType = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  projects?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  teams?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

export type PeopleFilter = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Administration capabilities for the authorized person on a specific resource (invite/change role/access/revoke). */
export type PermissionAdministration = {
  can_change_access_level?: Maybe<Scalars["Boolean"]["output"]>;
  can_change_role?: Maybe<Scalars["Boolean"]["output"]>;
  can_invite?: Maybe<Scalars["Boolean"]["output"]>;
  can_revoke?: Maybe<Scalars["Boolean"]["output"]>;
  constraints?: Maybe<PermissionAdministrationConstraints>;
  grantable_access_levels?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  grantable_roles?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** Unique identifier for client-side caching. */
  id?: Maybe<Scalars["String"]["output"]>;
  max_grant_access_level?: Maybe<Scalars["String"]["output"]>;
  max_grant_role?: Maybe<Scalars["String"]["output"]>;
};

/** Structured constraints the client can use for safe permission admin UX. */
export type PermissionAdministrationConstraints = {
  notes?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  organization_full_implies_admin?: Maybe<Scalars["Boolean"]["output"]>;
  workspace_admin_edit_no_manage_people?: Maybe<Scalars["Boolean"]["output"]>;
};

/** A person */
export type Person = {
  assessment_orders?: Maybe<Array<Maybe<AssessmentOrder>>>;
  avatar?: Maybe<Scalars["String"]["output"]>;
  completed_dim_types?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  invite?: Maybe<PersonInvite>;
  is_contact?: Maybe<Scalars["Boolean"]["output"]>;
  is_guest?: Maybe<Scalars["Boolean"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedin?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  roles?: Maybe<Array<Maybe<PersonRole>>>;
  /** @deprecated This field is deprecated. Use notes instead */
  summary?: Maybe<Summary>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
};

/** An invite */
export type PersonInvite = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  secret?: Maybe<Scalars["String"]["output"]>;
};

/** A person note */
export type PersonNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type PersonNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A list object of roles for a person */
export type PersonRole = {
  /** The access control of the person. */
  access_level?: Maybe<Scalars["String"]["output"]>;
  /** The actions the person has for the role. */
  actions?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** People administration capabilities for the authorized user on this resource (invite/change role/access/revoke). */
  administration?: Maybe<PermissionAdministration>;
  /** The context identifier for the role. */
  id?: Maybe<Scalars["String"]["output"]>;
  /** The context object identifier. */
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  /** This field is needed to have a unique identifier for the role for Apollo Client caching. */
  person_id?: Maybe<Scalars["Int"]["output"]>;
  /** The role of the person. */
  role?: Maybe<Scalars["String"]["output"]>;
  /** The context type of role. */
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Position kanban step */
export type PositionKanbanStep = {
  action?: Maybe<Scalars["String"]["output"]>;
  actionTitle?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  people?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** A project */
export type Project = {
  candidates?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  client_name?: Maybe<Scalars["String"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  kanban_columns?: Maybe<Array<Maybe<PositionKanbanStep>>>;
  meta?: Maybe<Scalars["JSON"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
  scorecard_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
};

export type ProjectAccessLevel = "FULL" | "NONE" | "READ";

export type ProjectAssessmentRowInput = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  dimensions?: InputMaybe<Array<InputMaybe<AssessmentRowDimensionInput>>>;
  group_title?: InputMaybe<Scalars["String"]["input"]>;
  icon?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  order?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** A note */
export type ProjectNote = {
  created_at?: Maybe<Scalars["String"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  text?: Maybe<Scalars["String"]["output"]>;
  /** Default is 'note'. */
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["String"]["output"]>;
};

export type ProjectRelationObjectInput = {
  access_level?: InputMaybe<ProjectAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<ProjectRoles>;
};

export type ProjectRoles = "CANDIDATE" | "COLLABORATOR";

export type ProjectsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Redirect information */
export type RedirectType = {
  account_id?: Maybe<Scalars["Int"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type ResourceType = "ACCOUNT" | "ORGANIZATION" | "PROJECT" | "TEAM";

/** Root level for all database mutations */
export type RootMutation = {
  acceptInvite?: Maybe<AcceptInviteMutationResponse>;
  addPeople?: Maybe<MutationResponse>;
  archiveOrganization?: Maybe<MutationResponse>;
  assessmentLinkOrder?: Maybe<Scalars["String"]["output"]>;
  cloneProjectScorecardToWorkspace?: Maybe<MutationResponse>;
  completeOnboarding?: Maybe<Scalars["Boolean"]["output"]>;
  completeOnboardingStep?: Maybe<MutationResponse>;
  createAccount?: Maybe<MutationResponse>;
  createAssessment?: Maybe<Assessment>;
  createOrganization?: Maybe<OrganizationType>;
  createProject?: Maybe<Project>;
  createTask?: Maybe<MutationResponse>;
  createTeam?: Maybe<Team>;
  deleteAssessment?: Maybe<Assessment>;
  deleteCandidateAttachment?: Maybe<Scalars["Int"]["output"]>;
  deleteOrg?: Maybe<MutationResponse>;
  deletePersonNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteProject?: Maybe<Project>;
  deleteProjectAssessmentRow?: Maybe<MutationResponse>;
  deleteProjectAssessmentRows?: Maybe<MutationResponse>;
  deleteProjectNote?: Maybe<MutationResponse>;
  deleteScorecard?: Maybe<MutationResponse>;
  deleteScorecardRows?: Maybe<MutationResponse>;
  deleteTeam?: Maybe<MutationResponse>;
  deleteTeamNote?: Maybe<Scalars["Boolean"]["output"]>;
  deleteUserNote?: Maybe<Scalars["Boolean"]["output"]>;
  discardSurveyAnswers?: Maybe<MutationResponse>;
  evaluatePerson?: Maybe<AssessmentEvaluation>;
  finishAssessmentOrder?: Maybe<MutationResponse>;
  finishSurveyMutation?: Maybe<ActiveSurvey>;
  modifyTeam?: Maybe<Team>;
  removeAvatar?: Maybe<Viewer>;
  removePersonFromOrganization?: Maybe<MutationResponse>;
  removePersonFromPosition?: Maybe<MutationResponse>;
  removePersonFromTeam?: Maybe<MutationResponse>;
  removePersonFromWorkspace?: Maybe<MutationResponse>;
  reorderPositionKanban?: Maybe<MutationResponse>;
  resendInvite?: Maybe<MutationResponse>;
  saveSurveyAnswer?: Maybe<MutationResponse>;
  saveSurveyAnswers?: Maybe<MutationResponse>;
  sendContactInvite?: Maybe<MutationResponse>;
  sendProfileReminder?: Maybe<Scalars["Boolean"]["output"]>;
  setNewAccountOnboardingUsecase?: Maybe<Scalars["Boolean"]["output"]>;
  startFileEmbedding?: Maybe<Scalars["Boolean"]["output"]>;
  toggleGettingStarted?: Maybe<Viewer>;
  toggleShowPositionTour?: Maybe<Viewer>;
  toggleShowTeamTour?: Maybe<Viewer>;
  updateAccount?: Maybe<Account>;
  updateOrg?: Maybe<OrganizationType>;
  updatePassword?: Maybe<Viewer>;
  updateProject?: Maybe<MutationResponse>;
  updateUser?: Maybe<Viewer>;
  uploadAttachment?: Maybe<MutationResponse>;
  uploadAvatarMutation?: Maybe<Viewer>;
  upsertAssessmentNote?: Maybe<AssessmentNote>;
  upsertAssessmentSummary?: Maybe<MutationResponse>;
  upsertNote?: Maybe<Note>;
  /** This endpoint currently only supports updating existing person essential information. Person is not upserted when not found. */
  upsertPerson?: Maybe<MutationResponse>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonAccessLevel?: Maybe<MutationResponse>;
  upsertPersonNote?: Maybe<PersonNoteType>;
  /** This endpoint upserts an existing person role in the context of the organization, account or team. */
  upsertPersonRole?: Maybe<MutationResponse>;
  upsertPersonScore?: Maybe<Dimension>;
  upsertPersonScoresBulk?: Maybe<MutationResponse>;
  upsertProjectAssessmentRows?: Maybe<MutationResponse>;
  upsertProjectNote?: Maybe<ProjectNote>;
  upsertScorecard?: Maybe<Scorecard>;
  upsertScorecardRows?: Maybe<MutationResponse>;
  upsertTeamNote?: Maybe<TeamNoteType>;
  upsertUserNote?: Maybe<UserNoteType>;
  /**
   *
   *     Validates multiple emails against people in the resource.
   *     For each email, if person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   */
  validatePeopleByEmail?: Maybe<ValidatePeopleResponse>;
  /**
   *
   *     Validates an email against people in the account.
   *     If person exists, returns person object with roles list, otherwise returns an empty person record.
   *
   *     Response can be used to invite new people to the account or account resources (e.g., positions, teams, etc.) and/or
   *     validate the persons availability to add to resources.
   *
   * @deprecated Use validatePeopleByEmail instead. This endpoint will be removed in the future.
   */
  validatePersonByEmail?: Maybe<ValidatePersonResponse>;
};

/** Root level for all database mutations */
export type RootMutationAcceptInviteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAddPeopleArgs = {
  people?: InputMaybe<Array<InputMaybe<AddPersonInput>>>;
};

/** Root level for all database mutations */
export type RootMutationArchiveOrganizationArgs = {
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationAssessmentLinkOrderArgs = {
  assessmentType: Scalars["String"]["input"];
  redirectUrl: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCloneProjectScorecardToWorkspaceArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  projectId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCompleteOnboardingStepArgs = {
  step: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAccountArgs = {
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateAssessmentArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateOrganizationArgs = {
  account_id: Scalars["Int"]["input"];
  name: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  org_id: Scalars["Int"]["input"];
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationCreateTaskArgs = {
  authorizedKeys?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  params?: InputMaybe<Scalars["JSONObject"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationCreateTeamArgs = {
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteAssessmentArgs = {
  assessment_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteCandidateAttachmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeletePersonNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rowIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

/** Root level for all database mutations */
export type RootMutationDeleteProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteScorecardRowsArgs = {
  row_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationDeleteTeamNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDeleteUserNoteArgs = {
  id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationDiscardSurveyAnswersArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationEvaluatePersonArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  evaluation?: InputMaybe<Scalars["Int"]["input"]>;
  meta?: InputMaybe<Scalars["JSONObject"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationFinishAssessmentOrderArgs = {
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationFinishSurveyMutationArgs = {
  answers?: InputMaybe<Array<InputMaybe<SurveyAnswerInputType>>>;
  survey_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationModifyTeamArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name: Scalars["String"]["input"];
  org_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromOrganizationArgs = {
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromPositionArgs = {
  keep_access?: InputMaybe<Scalars["Boolean"]["input"]>;
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromTeamArgs = {
  person_id: Scalars["Int"]["input"];
  team_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationRemovePersonFromWorkspaceArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationReorderPositionKanbanArgs = {
  column_id: Scalars["Int"]["input"];
  order: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  position_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationResendInviteArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswerArgs = {
  answer: Scalars["Int"]["input"];
  assessment_order_id: Scalars["Int"]["input"];
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSaveSurveyAnswersArgs = {
  answers: Array<AssessmentSurveyAnswerInput>;
  assessment_order_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendContactInviteArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSendProfileReminderArgs = {
  person_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationSetNewAccountOnboardingUsecaseArgs = {
  usecase: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationStartFileEmbeddingArgs = {
  file_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateAccountArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateOrgArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdatePasswordArgs = {
  new_password: Scalars["String"]["input"];
  old_password: Scalars["String"]["input"];
  repeat_new_password: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpdateProjectArgs = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpdateUserArgs = {
  companySize?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedIn?: InputMaybe<Scalars["String"]["input"]>;
  occupation?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUploadAttachmentArgs = {
  description?: InputMaybe<Scalars["String"]["input"]>;
  file?: InputMaybe<Scalars["Upload"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id: Scalars["Int"]["input"];
  size: Scalars["Int"]["input"];
  tags?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

/** Root level for all database mutations */
export type RootMutationUploadAvatarMutationArgs = {
  image?: InputMaybe<Scalars["Upload"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentNoteArgs = {
  assessment_id: Scalars["Int"]["input"];
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  text: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertAssessmentSummaryArgs = {
  assessment_id: Scalars["Int"]["input"];
  summary?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertNoteArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  row_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
  user_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  first_name?: InputMaybe<Scalars["String"]["input"]>;
  last_name?: InputMaybe<Scalars["String"]["input"]>;
  linkedin?: InputMaybe<Scalars["String"]["input"]>;
  person_id: Scalars["Int"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonAccessLevelArgs = {
  access_level: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonRoleArgs = {
  id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  role: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoreArgs = {
  dim_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertPersonScoresBulkArgs = {
  person_id: Scalars["Int"]["input"];
  scores: Array<InputMaybe<ScoreInput>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectAssessmentRowsArgs = {
  project_id: Scalars["Int"]["input"];
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
};

/** Root level for all database mutations */
export type RootMutationUpsertProjectNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  text?: InputMaybe<Scalars["String"]["input"]>;
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardArgs = {
  category_id?: InputMaybe<Scalars["Int"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  tag_id?: InputMaybe<Scalars["Int"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationUpsertScorecardRowsArgs = {
  rows?: InputMaybe<Array<InputMaybe<ProjectAssessmentRowInput>>>;
  scorecard_id: Scalars["Int"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertTeamNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationUpsertUserNoteArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
  note: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

/** Root level for all database mutations */
export type RootMutationValidatePeopleByEmailArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resource?: InputMaybe<ResourceType>;
  resourceId?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root level for all database mutations */
export type RootMutationValidatePersonByEmailArgs = {
  email?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQuery = {
  account?: Maybe<Account>;
  accounts?: Maybe<Array<Maybe<Account>>>;
  assessment?: Maybe<Assessment>;
  assessmentOrder?: Maybe<AssessmentOrder>;
  assessmentOrderCompletion?: Maybe<AssessmentOrder>;
  assessments?: Maybe<Array<Maybe<Assessment>>>;
  attachmentReadSignedUrl?: Maybe<Scalars["String"]["output"]>;
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  authorizedPerson?: Maybe<Person>;
  dictionary?: Maybe<Array<Maybe<DimText>>>;
  dimensions?: Maybe<Array<Maybe<Dimension>>>;
  evaluations?: Maybe<Array<Maybe<AssessmentEvaluation>>>;
  notes?: Maybe<Array<Maybe<Note>>>;
  notifications?: Maybe<Array<Maybe<Notification>>>;
  organization?: Maybe<OrganizationType>;
  organizations?: Maybe<Array<Maybe<OrganizationType>>>;
  people?: Maybe<Array<Maybe<Person>>>;
  person?: Maybe<Person>;
  personNotes?: Maybe<Array<Maybe<PersonNoteType>>>;
  project?: Maybe<Project>;
  projectNotes?: Maybe<Array<Maybe<ProjectNote>>>;
  projects?: Maybe<Array<Maybe<Project>>>;
  scorecard?: Maybe<Scorecard>;
  scorecardTagsAndCategories?: Maybe<ScorecardTagAndCategory>;
  scorecards?: Maybe<Array<Maybe<Scorecard>>>;
  shareCandidateProfile?: Maybe<Scalars["String"]["output"]>;
  survey?: Maybe<ActiveSurvey>;
  surveys?: Maybe<Array<Maybe<AssessmentSurvey>>>;
  team?: Maybe<Team>;
  teamNotes?: Maybe<Array<Maybe<TeamNoteType>>>;
  teams?: Maybe<Array<Maybe<Team>>>;
  userNotes?: Maybe<Array<Maybe<UserNoteType>>>;
  viewer?: Maybe<Viewer>;
  wisgptContextToken?: Maybe<Scalars["String"]["output"]>;
};

/** Root query */
export type RootQueryAccountArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentOrderCompletionArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAssessmentsArgs = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryAttachmentReadSignedUrlArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryAttachmentsArgs = {
  filter?: InputMaybe<AttachmentsFilter>;
};

/** Root query */
export type RootQueryDimensionsArgs = {
  filter?: InputMaybe<DimensionsFilter>;
};

/** Root query */
export type RootQueryEvaluationsArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryNotesArgs = {
  filter?: InputMaybe<NotesFilter>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Root query */
export type RootQueryOrganizationArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryOrganizationsArgs = {
  account_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPeopleArgs = {
  filter?: InputMaybe<PeopleFilter>;
};

/** Root query */
export type RootQueryPersonArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryPersonNotesArgs = {
  filter?: InputMaybe<PersonNotesFilter>;
};

/** Root query */
export type RootQueryProjectArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryProjectNotesArgs = {
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** Root query */
export type RootQueryProjectsArgs = {
  filter: ProjectsFilter;
};

/** Root query */
export type RootQueryScorecardArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryScorecardsArgs = {
  scorecard_ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

/** Root query */
export type RootQueryShareCandidateProfileArgs = {
  org_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  project_id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQuerySurveyArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamArgs = {
  id: Scalars["Int"]["input"];
};

/** Root query */
export type RootQueryTeamNotesArgs = {
  filter?: InputMaybe<TeamNotesFilter>;
};

/** Root query */
export type RootQueryTeamsArgs = {
  filter: TeamsFilter;
};

/** Root query */
export type RootQueryUserNotesArgs = {
  filter?: InputMaybe<UserNotesFilter>;
};

/** Root query */
export type RootQueryWisgptContextTokenArgs = {
  assessment_id?: InputMaybe<Scalars["Int"]["input"]>;
  org_id?: InputMaybe<Scalars["Int"]["input"]>;
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  position_id?: InputMaybe<Scalars["Int"]["input"]>;
  project_id?: InputMaybe<Scalars["Int"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_config?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A score */
export type Score = {
  key?: Maybe<Scalars["String"]["output"]>;
  obj_id?: Maybe<Scalars["Int"]["output"]>;
  obj_type?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type ScoreInput = {
  dim_id: Scalars["Int"]["input"];
  score: Scalars["Float"]["input"];
};

/** Assessment scorecard */
export type Scorecard = {
  category?: Maybe<ScorecardCategory>;
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_global?: Maybe<Scalars["Boolean"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  objectives?: Maybe<Scalars["String"]["output"]>;
  project_id?: Maybe<Scalars["Int"]["output"]>;
  rows?: Maybe<Array<Maybe<ScorecardRow>>>;
  tag?: Maybe<ScorecardTag>;
  title?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

/** Scorecard category */
export type ScorecardCategory = {
  color?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRow = {
  color?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  dimensions?: Maybe<Array<Maybe<ScorecardRowDimension>>>;
  example_prompts?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  group_title?: Maybe<Scalars["String"]["output"]>;
  icon?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  meta?: Maybe<Scalars["JSONObject"]["output"]>;
  order?: Maybe<Scalars["Int"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardRowDimension = {
  dim_id?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  target_max?: Maybe<Scalars["Int"]["output"]>;
  target_min?: Maybe<Scalars["Int"]["output"]>;
};

/** Tag for scorecard */
export type ScorecardTag = {
  id?: Maybe<Scalars["Int"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type ScorecardTagAndCategory = {
  categories?: Maybe<Array<Maybe<ScorecardCategory>>>;
  tags?: Maybe<Array<Maybe<ScorecardTag>>>;
};

/** A profile summary */
export type Summary = {
  text?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type Survey = {
  assessment_type?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  intro?: Maybe<Scalars["JSONObject"]["output"]>;
  rows?: Maybe<Array<Maybe<AssessmentSurveyRow>>>;
  ui?: Maybe<Scalars["String"]["output"]>;
};

export type SurveyAnswerInputType = {
  answer?: InputMaybe<Scalars["Int"]["input"]>;
  duration_ms?: InputMaybe<Scalars["Int"]["input"]>;
  obj_id?: InputMaybe<Scalars["Int"]["input"]>;
  obj_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  question_dim_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_id?: InputMaybe<Scalars["Int"]["input"]>;
  subject_type_id?: InputMaybe<Scalars["Int"]["input"]>;
  survey_row_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Survey answer object */
export type SurveyAnswerObject = {
  answer?: Maybe<Scalars["Int"]["output"]>;
  duration_ms?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  obj_type_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  subject_id?: Maybe<Scalars["Int"]["output"]>;
  subject_type_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A survey completion */
export type SurveyCompletion = {
  completed?: Maybe<Scalars["Boolean"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_type?: Maybe<Scalars["String"]["output"]>;
  text_id?: Maybe<Scalars["String"]["output"]>;
};

/** The survey row with dimension */
export type SurveyRowLoaded = {
  dimension?: Maybe<DimensionLoaded>;
  external_trait_id?: Maybe<Scalars["Int"]["output"]>;
  question_dim_id?: Maybe<Scalars["Int"]["output"]>;
  row_block_id?: Maybe<Scalars["Int"]["output"]>;
  row_id?: Maybe<Scalars["Int"]["output"]>;
  survey_id?: Maybe<Scalars["Int"]["output"]>;
  survey_row_id?: Maybe<Scalars["Int"]["output"]>;
};

/** A Team */
export type Team = {
  admin_rights?: Maybe<Scalars["Boolean"]["output"]>;
  config?: Maybe<Scalars["JSON"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  is_demo?: Maybe<Scalars["Boolean"]["output"]>;
  members?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  name?: Maybe<Scalars["String"]["output"]>;
  org_id?: Maybe<Scalars["Int"]["output"]>;
};

export type TeamAccessLevel = "FULL" | "NONE" | "READ";

/** A team note */
export type TeamNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  person_id?: Maybe<Scalars["Int"]["output"]>;
  team_id?: Maybe<Scalars["Int"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
};

export type TeamNotesFilter = {
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type TeamRelationObjectInput = {
  access_level?: InputMaybe<TeamAccessLevel>;
  id: Scalars["Int"]["input"];
  role?: InputMaybe<TeamRoles>;
};

export type TeamRoles = "COLLABORATOR" | "MEMBER";

export type TeamsFilter = {
  org_id: Scalars["Int"]["input"];
  person_id?: InputMaybe<Scalars["Int"]["input"]>;
};

/** A user note */
export type UserNoteType = {
  created_at?: Maybe<Scalars["Date"]["output"]>;
  created_by?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  note?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  updated_at?: Maybe<Scalars["Date"]["output"]>;
  user_id?: Maybe<Scalars["Int"]["output"]>;
};

export type UserNotesFilter = {
  type?: InputMaybe<Scalars["String"]["input"]>;
};

/** User onboarding information */
export type UserOnboarding = {
  completed_at?: Maybe<Scalars["Date"]["output"]>;
  skipped_at?: Maybe<Scalars["Date"]["output"]>;
  steps?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

/** Bulk person validation response */
export type ValidatePeopleResponse = {
  people?: Maybe<Array<Maybe<Person>>>;
};

/** Person validation response */
export type ValidatePersonResponse = {
  person?: Maybe<Person>;
};

/** The viewer who has logged in. */
export type Viewer = {
  avatar_url?: Maybe<Scalars["String"]["output"]>;
  birthday?: Maybe<Scalars["String"]["output"]>;
  default_account_id?: Maybe<Scalars["Int"]["output"]>;
  default_organization_id?: Maybe<Scalars["Int"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  first_name?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated This field is deprecated and will be removed in a future version. This just returns null */
  has_password_login?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  initials?: Maybe<Scalars["String"]["output"]>;
  last_name?: Maybe<Scalars["String"]["output"]>;
  linkedIn?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  occupation?: Maybe<Scalars["String"]["output"]>;
  onboarding?: Maybe<UserOnboarding>;
  phone?: Maybe<Scalars["String"]["output"]>;
  showGettingStarted?: Maybe<Scalars["Boolean"]["output"]>;
  showPositionTour?: Maybe<Scalars["Boolean"]["output"]>;
  showTeamTour?: Maybe<Scalars["Boolean"]["output"]>;
  survey_completion?: Maybe<Array<Maybe<SurveyCompletion>>>;
  /** @deprecated This field is deprecated and will be removed in a future version. Use survey_completion instead. This just returns null */
  surveys?: Maybe<Array<Maybe<ActiveSurvey>>>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type WorkspaceAccessLevel = "EDIT" | "FULL" | "LIMITED" | "NONE";

export type WorkspaceRoles =
  | "ADMIN"
  | "CANDIDATE"
  | "CONTACT"
  | "MEMBER"
  | "OWNER";

export type CloneProjectScorecardMutationVariables = Exact<{
  projectId: Scalars["Int"]["input"];
  title?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CloneProjectScorecardMutation = {
  __typename: "RootMutation";
  cloneProjectScorecardToWorkspace?:
    | {
        __typename: "MutationResponse";
        ids?: Array<number | null | undefined> | null | undefined;
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type CreateProjectMutationVariables = Exact<{
  name: Scalars["String"]["input"];
  orgId: Scalars["Int"]["input"];
  description?: InputMaybe<Scalars["String"]["input"]>;
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  teamId?: InputMaybe<Scalars["Int"]["input"]>;
  scorecardId?: InputMaybe<Scalars["Int"]["input"]>;
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  config?: InputMaybe<Scalars["JSONObject"]["input"]>;
}>;

export type CreateProjectMutation = {
  __typename: "RootMutation";
  createProject?:
    | {
        __typename: "Project";
        id?: number | null | undefined;
        name?: string | null | undefined;
        description?: string | null | undefined;
        team_id?: number | null | undefined;
        org_id?: number | null | undefined;
        objectives?: string | null | undefined;
        scorecard_id?: number | null | undefined;
        is_demo?: boolean | null | undefined;
        candidates?: Array<number | null | undefined> | null | undefined;
        kanban_columns?:
          | Array<
              | {
                  __typename: "PositionKanbanStep";
                  id?: number | null | undefined;
                  title?: string | null | undefined;
                  actionTitle?: string | null | undefined;
                  action?: string | null | undefined;
                  people?: Array<number | null | undefined> | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteProjectMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type DeleteProjectMutation = {
  __typename: "RootMutation";
  deleteProject?:
    | {
        __typename: "Project";
        id?: number | null | undefined;
        team_id?: number | null | undefined;
        org_id?: number | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteProjectNoteMutationVariables = Exact<{
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DeleteProjectNoteMutation = {
  __typename: "RootMutation";
  deleteProjectNote?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type RemovePersonFromPositionMutationVariables = Exact<{
  personId: Scalars["Int"]["input"];
  positionId: Scalars["Int"]["input"];
  keepAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type RemovePersonFromPositionMutation = {
  __typename: "RootMutation";
  removePersonFromPosition?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ReorderPositionKanbanMutationVariables = Exact<{
  position_id: Scalars["Int"]["input"];
  person_id: Scalars["Int"]["input"];
  column_id: Scalars["Int"]["input"];
  order: Scalars["Int"]["input"];
}>;

export type ReorderPositionKanbanMutation = {
  __typename: "RootMutation";
  reorderPositionKanban?:
    | {
        __typename: "MutationResponse";
        message?: string | null | undefined;
        success?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  description?: InputMaybe<Scalars["String"]["input"]>;
  scorecard_id?: InputMaybe<Scalars["Int"]["input"]>;
  objectives?: InputMaybe<Scalars["String"]["input"]>;
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  team_id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpdateProjectMutation = {
  __typename: "RootMutation";
  updateProject?:
    | {
        __typename: "MutationResponse";
        success?: boolean | null | undefined;
        message?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpsertProjectNoteMutationVariables = Exact<{
  type: Scalars["String"]["input"];
  text?: InputMaybe<Scalars["String"]["input"]>;
  projectId?: InputMaybe<Scalars["Int"]["input"]>;
  personId?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpsertProjectNoteMutation = {
  __typename: "RootMutation";
  upsertProjectNote?:
    | {
        __typename: "ProjectNote";
        id?: number | null | undefined;
        text?: string | null | undefined;
        type?: string | null | undefined;
        project_id?: number | null | undefined;
        person_id?: number | null | undefined;
        created_by?: number | null | undefined;
        created_at?: string | null | undefined;
        updated_at?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ToggleShowPositionTourMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ToggleShowPositionTourMutation = {
  __typename: "RootMutation";
  toggleShowPositionTour?:
    | {
        __typename: "Viewer";
        id?: number | null | undefined;
        showPositionTour?: boolean | null | undefined;
      }
    | null
    | undefined;
};

export type ProjectQueryVariables = Exact<{
  positionId: Scalars["Int"]["input"];
}>;

export type ProjectQuery = {
  __typename: "RootQuery";
  project?:
    | {
        __typename: "Project";
        id?: number | null | undefined;
        name?: string | null | undefined;
        description?: string | null | undefined;
        team_id?: number | null | undefined;
        org_id?: number | null | undefined;
        scorecard_id?: number | null | undefined;
        client_name?: string | null | undefined;
        is_demo?: boolean | null | undefined;
        meta?: any | null | undefined;
        config?: any | null | undefined;
        kanban_columns?:
          | Array<
              | {
                  __typename: "PositionKanbanStep";
                  people?: Array<number | null | undefined> | null | undefined;
                  id?: number | null | undefined;
                  title?: string | null | undefined;
                  actionTitle?: string | null | undefined;
                  action?: string | null | undefined;
                }
              | null
              | undefined
            >
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ProjectNotesQueryVariables = Exact<{
  personId: Scalars["Int"]["input"];
  projectId: Scalars["Int"]["input"];
  type?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProjectNotesQuery = {
  __typename: "RootQuery";
  projectNotes?:
    | Array<
        | {
            __typename: "ProjectNote";
            id?: number | null | undefined;
            text?: string | null | undefined;
            type?: string | null | undefined;
            project_id?: number | null | undefined;
            person_id?: number | null | undefined;
            created_by?: number | null | undefined;
            created_at?: string | null | undefined;
            updated_at?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type ProjectsQueryVariables = Exact<{
  filter: ProjectsFilter;
}>;

export type ProjectsQuery = {
  __typename: "RootQuery";
  projects?:
    | Array<
        | {
            __typename: "Project";
            id?: number | null | undefined;
            name?: string | null | undefined;
            description?: string | null | undefined;
            candidates?: Array<number | null | undefined> | null | undefined;
            scorecard_id?: number | null | undefined;
            team_id?: number | null | undefined;
            client_name?: string | null | undefined;
            meta?: any | null | undefined;
            config?: any | null | undefined;
            kanban_columns?:
              | Array<
                  | {
                      __typename: "PositionKanbanStep";
                      people?:
                        | Array<number | null | undefined>
                        | null
                        | undefined;
                      id?: number | null | undefined;
                    }
                  | null
                  | undefined
                >
              | null
              | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type RoleFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
  actions?: Array<string | null | undefined> | null | undefined;
  administration?:
    | {
        __typename: "PermissionAdministration";
        id?: string | null | undefined;
        can_change_access_level?: boolean | null | undefined;
        can_change_role?: boolean | null | undefined;
        can_invite?: boolean | null | undefined;
        can_revoke?: boolean | null | undefined;
        max_grant_role?: string | null | undefined;
        max_grant_access_level?: string | null | undefined;
        grantable_roles?: Array<string | null | undefined> | null | undefined;
        grantable_access_levels?:
          | Array<string | null | undefined>
          | null
          | undefined;
        constraints?:
          | {
              __typename: "PermissionAdministrationConstraints";
              organization_full_implies_admin?: boolean | null | undefined;
              workspace_admin_edit_no_manage_people?:
                | boolean
                | null
                | undefined;
              notes?: Array<string | null | undefined> | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type RoleLiteFieldsFragment = {
  __typename: "PersonRole";
  id?: string | null | undefined;
  obj_id?: number | null | undefined;
  role?: string | null | undefined;
  type?: string | null | undefined;
  access_level?: string | null | undefined;
  person_id?: number | null | undefined;
};

export const RoleFieldsFragmentDoc = gql`
  fragment RoleFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
    actions
    administration {
      id
      can_change_access_level
      can_change_role
      can_invite
      can_revoke
      max_grant_role
      max_grant_access_level
      grantable_roles
      grantable_access_levels
      constraints {
        organization_full_implies_admin
        workspace_admin_edit_no_manage_people
        notes
      }
    }
  }
`;
export const RoleLiteFieldsFragmentDoc = gql`
  fragment RoleLiteFields on PersonRole {
    id
    obj_id
    role
    type
    access_level
    person_id
  }
`;
export const CloneProjectScorecardDocument = gql`
  mutation CloneProjectScorecard(
    $projectId: Int!
    $title: String
    $description: String
  ) {
    cloneProjectScorecardToWorkspace(
      projectId: $projectId
      title: $title
      description: $description
    ) {
      ids
      message
      success
    }
  }
`;
export type CloneProjectScorecardMutationFn = Apollo.MutationFunction<
  CloneProjectScorecardMutation,
  CloneProjectScorecardMutationVariables
>;

/**
 * __useCloneProjectScorecardMutation__
 *
 * To run a mutation, you first call `useCloneProjectScorecardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectScorecardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectScorecardMutation, { data, loading, error }] = useCloneProjectScorecardMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCloneProjectScorecardMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CloneProjectScorecardMutation,
    CloneProjectScorecardMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CloneProjectScorecardMutation,
    CloneProjectScorecardMutationVariables
  >(CloneProjectScorecardDocument, options);
}
export type CloneProjectScorecardMutationHookResult = ReturnType<
  typeof useCloneProjectScorecardMutation
>;
export type CloneProjectScorecardMutationResult =
  Apollo.MutationResult<CloneProjectScorecardMutation>;
export type CloneProjectScorecardMutationOptions = Apollo.BaseMutationOptions<
  CloneProjectScorecardMutation,
  CloneProjectScorecardMutationVariables
>;
export const CreateProjectDocument = gql`
  mutation CreateProject(
    $name: String!
    $orgId: Int!
    $description: String
    $objectives: String
    $teamId: Int
    $scorecardId: Int
    $client_name: String
    $config: JSONObject
  ) {
    createProject(
      name: $name
      org_id: $orgId
      description: $description
      objectives: $objectives
      team_id: $teamId
      scorecard_id: $scorecardId
      client_name: $client_name
      config: $config
    ) {
      id
      name
      description
      team_id
      org_id
      objectives
      kanban_columns {
        id
        title
        actionTitle
        action
        people
      }
      scorecard_id
      is_demo
      candidates
    }
  }
`;
export type CreateProjectMutationFn = Apollo.MutationFunction<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      name: // value for 'name'
 *      orgId: // value for 'orgId'
 *      description: // value for 'description'
 *      objectives: // value for 'objectives'
 *      teamId: // value for 'teamId'
 *      scorecardId: // value for 'scorecardId'
 *      client_name: // value for 'client_name'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useCreateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateProjectMutation,
    CreateProjectMutationVariables
  >(CreateProjectDocument, options);
}
export type CreateProjectMutationHookResult = ReturnType<
  typeof useCreateProjectMutation
>;
export type CreateProjectMutationResult =
  Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<
  CreateProjectMutation,
  CreateProjectMutationVariables
>;
export const DeleteProjectDocument = gql`
  mutation DeleteProject($id: Int!) {
    deleteProject(id: $id) {
      id
      team_id
      org_id
    }
  }
`;
export type DeleteProjectMutationFn = Apollo.MutationFunction<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectMutation,
    DeleteProjectMutationVariables
  >(DeleteProjectDocument, options);
}
export type DeleteProjectMutationHookResult = ReturnType<
  typeof useDeleteProjectMutation
>;
export type DeleteProjectMutationResult =
  Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectMutation,
  DeleteProjectMutationVariables
>;
export const DeleteProjectNoteDocument = gql`
  mutation DeleteProjectNote($id: Int) {
    deleteProjectNote(id: $id) {
      message
      success
    }
  }
`;
export type DeleteProjectNoteMutationFn = Apollo.MutationFunction<
  DeleteProjectNoteMutation,
  DeleteProjectNoteMutationVariables
>;

/**
 * __useDeleteProjectNoteMutation__
 *
 * To run a mutation, you first call `useDeleteProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectNoteMutation, { data, loading, error }] = useDeleteProjectNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteProjectNoteMutation,
    DeleteProjectNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteProjectNoteMutation,
    DeleteProjectNoteMutationVariables
  >(DeleteProjectNoteDocument, options);
}
export type DeleteProjectNoteMutationHookResult = ReturnType<
  typeof useDeleteProjectNoteMutation
>;
export type DeleteProjectNoteMutationResult =
  Apollo.MutationResult<DeleteProjectNoteMutation>;
export type DeleteProjectNoteMutationOptions = Apollo.BaseMutationOptions<
  DeleteProjectNoteMutation,
  DeleteProjectNoteMutationVariables
>;
export const RemovePersonFromPositionDocument = gql`
  mutation RemovePersonFromPosition(
    $personId: Int!
    $positionId: Int!
    $keepAccess: Boolean
  ) {
    removePersonFromPosition(
      person_id: $personId
      position_id: $positionId
      keep_access: $keepAccess
    ) {
      message
      success
    }
  }
`;
export type RemovePersonFromPositionMutationFn = Apollo.MutationFunction<
  RemovePersonFromPositionMutation,
  RemovePersonFromPositionMutationVariables
>;

/**
 * __useRemovePersonFromPositionMutation__
 *
 * To run a mutation, you first call `useRemovePersonFromPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePersonFromPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePersonFromPositionMutation, { data, loading, error }] = useRemovePersonFromPositionMutation({
 *   variables: {
 *      personId: // value for 'personId'
 *      positionId: // value for 'positionId'
 *      keepAccess: // value for 'keepAccess'
 *   },
 * });
 */
export function useRemovePersonFromPositionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePersonFromPositionMutation,
    RemovePersonFromPositionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePersonFromPositionMutation,
    RemovePersonFromPositionMutationVariables
  >(RemovePersonFromPositionDocument, options);
}
export type RemovePersonFromPositionMutationHookResult = ReturnType<
  typeof useRemovePersonFromPositionMutation
>;
export type RemovePersonFromPositionMutationResult =
  Apollo.MutationResult<RemovePersonFromPositionMutation>;
export type RemovePersonFromPositionMutationOptions =
  Apollo.BaseMutationOptions<
    RemovePersonFromPositionMutation,
    RemovePersonFromPositionMutationVariables
  >;
export const ReorderPositionKanbanDocument = gql`
  mutation ReorderPositionKanban(
    $position_id: Int!
    $person_id: Int!
    $column_id: Int!
    $order: Int!
  ) {
    reorderPositionKanban(
      position_id: $position_id
      person_id: $person_id
      column_id: $column_id
      order: $order
    ) {
      message
      success
    }
  }
`;
export type ReorderPositionKanbanMutationFn = Apollo.MutationFunction<
  ReorderPositionKanbanMutation,
  ReorderPositionKanbanMutationVariables
>;

/**
 * __useReorderPositionKanbanMutation__
 *
 * To run a mutation, you first call `useReorderPositionKanbanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderPositionKanbanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderPositionKanbanMutation, { data, loading, error }] = useReorderPositionKanbanMutation({
 *   variables: {
 *      position_id: // value for 'position_id'
 *      person_id: // value for 'person_id'
 *      column_id: // value for 'column_id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReorderPositionKanbanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderPositionKanbanMutation,
    ReorderPositionKanbanMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReorderPositionKanbanMutation,
    ReorderPositionKanbanMutationVariables
  >(ReorderPositionKanbanDocument, options);
}
export type ReorderPositionKanbanMutationHookResult = ReturnType<
  typeof useReorderPositionKanbanMutation
>;
export type ReorderPositionKanbanMutationResult =
  Apollo.MutationResult<ReorderPositionKanbanMutation>;
export type ReorderPositionKanbanMutationOptions = Apollo.BaseMutationOptions<
  ReorderPositionKanbanMutation,
  ReorderPositionKanbanMutationVariables
>;
export const UpdateProjectDocument = gql`
  mutation UpdateProject(
    $id: Int!
    $name: String
    $description: String
    $scorecard_id: Int
    $objectives: String
    $client_name: String
    $team_id: Int
  ) {
    updateProject(
      id: $id
      name: $name
      description: $description
      scorecard_id: $scorecard_id
      objectives: $objectives
      client_name: $client_name
      team_id: $team_id
    ) {
      success
      message
    }
  }
`;
export type UpdateProjectMutationFn = Apollo.MutationFunction<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      scorecard_id: // value for 'scorecard_id'
 *      objectives: // value for 'objectives'
 *      client_name: // value for 'client_name'
 *      team_id: // value for 'team_id'
 *   },
 * });
 */
export function useUpdateProjectMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProjectMutation,
    UpdateProjectMutationVariables
  >(UpdateProjectDocument, options);
}
export type UpdateProjectMutationHookResult = ReturnType<
  typeof useUpdateProjectMutation
>;
export type UpdateProjectMutationResult =
  Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<
  UpdateProjectMutation,
  UpdateProjectMutationVariables
>;
export const UpsertProjectNoteDocument = gql`
  mutation UpsertProjectNote(
    $type: String!
    $text: String
    $projectId: Int
    $personId: Int
    $id: Int
  ) {
    upsertProjectNote(
      type: $type
      text: $text
      project_id: $projectId
      person_id: $personId
      id: $id
    ) {
      id
      text
      type
      project_id
      person_id
      created_by
      created_at
      updated_at
    }
  }
`;
export type UpsertProjectNoteMutationFn = Apollo.MutationFunction<
  UpsertProjectNoteMutation,
  UpsertProjectNoteMutationVariables
>;

/**
 * __useUpsertProjectNoteMutation__
 *
 * To run a mutation, you first call `useUpsertProjectNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertProjectNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertProjectNoteMutation, { data, loading, error }] = useUpsertProjectNoteMutation({
 *   variables: {
 *      type: // value for 'type'
 *      text: // value for 'text'
 *      projectId: // value for 'projectId'
 *      personId: // value for 'personId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpsertProjectNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertProjectNoteMutation,
    UpsertProjectNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertProjectNoteMutation,
    UpsertProjectNoteMutationVariables
  >(UpsertProjectNoteDocument, options);
}
export type UpsertProjectNoteMutationHookResult = ReturnType<
  typeof useUpsertProjectNoteMutation
>;
export type UpsertProjectNoteMutationResult =
  Apollo.MutationResult<UpsertProjectNoteMutation>;
export type UpsertProjectNoteMutationOptions = Apollo.BaseMutationOptions<
  UpsertProjectNoteMutation,
  UpsertProjectNoteMutationVariables
>;
export const ToggleShowPositionTourDocument = gql`
  mutation ToggleShowPositionTour {
    toggleShowPositionTour {
      id
      showPositionTour
    }
  }
`;
export type ToggleShowPositionTourMutationFn = Apollo.MutationFunction<
  ToggleShowPositionTourMutation,
  ToggleShowPositionTourMutationVariables
>;

/**
 * __useToggleShowPositionTourMutation__
 *
 * To run a mutation, you first call `useToggleShowPositionTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShowPositionTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShowPositionTourMutation, { data, loading, error }] = useToggleShowPositionTourMutation({
 *   variables: {
 *   },
 * });
 */
export function useToggleShowPositionTourMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleShowPositionTourMutation,
    ToggleShowPositionTourMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleShowPositionTourMutation,
    ToggleShowPositionTourMutationVariables
  >(ToggleShowPositionTourDocument, options);
}
export type ToggleShowPositionTourMutationHookResult = ReturnType<
  typeof useToggleShowPositionTourMutation
>;
export type ToggleShowPositionTourMutationResult =
  Apollo.MutationResult<ToggleShowPositionTourMutation>;
export type ToggleShowPositionTourMutationOptions = Apollo.BaseMutationOptions<
  ToggleShowPositionTourMutation,
  ToggleShowPositionTourMutationVariables
>;
export const ProjectDocument = gql`
  query Project($positionId: Int!) {
    project(id: $positionId) {
      id
      name
      description
      team_id
      org_id
      kanban_columns {
        people
        id
        title
        actionTitle
        action
      }
      scorecard_id
      client_name
      is_demo
      meta
      config
    }
  }
`;

/**
 * __useProjectQuery__
 *
 * To run a query within a React component, call `useProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectQuery({
 *   variables: {
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useProjectQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectQuery, ProjectQueryVariables> &
    ({ variables: ProjectQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  );
}
export function useProjectLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProjectQuery, ProjectQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  );
}
export function useProjectSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectQuery, ProjectQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectQuery, ProjectQueryVariables>(
    ProjectDocument,
    options
  );
}
export type ProjectQueryHookResult = ReturnType<typeof useProjectQuery>;
export type ProjectLazyQueryHookResult = ReturnType<typeof useProjectLazyQuery>;
export type ProjectSuspenseQueryHookResult = ReturnType<
  typeof useProjectSuspenseQuery
>;
export type ProjectQueryResult = Apollo.QueryResult<
  ProjectQuery,
  ProjectQueryVariables
>;
export const ProjectNotesDocument = gql`
  query ProjectNotes($personId: Int!, $projectId: Int!, $type: String) {
    projectNotes(person_id: $personId, project_id: $projectId, type: $type) {
      id
      text
      type
      project_id
      person_id
      created_by
      created_at
      updated_at
    }
  }
`;

/**
 * __useProjectNotesQuery__
 *
 * To run a query within a React component, call `useProjectNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectNotesQuery({
 *   variables: {
 *      personId: // value for 'personId'
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProjectNotesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProjectNotesQuery,
    ProjectNotesQueryVariables
  > &
    (
      | { variables: ProjectNotesQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectNotesQuery, ProjectNotesQueryVariables>(
    ProjectNotesDocument,
    options
  );
}
export function useProjectNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectNotesQuery,
    ProjectNotesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectNotesQuery, ProjectNotesQueryVariables>(
    ProjectNotesDocument,
    options
  );
}
export function useProjectNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProjectNotesQuery,
        ProjectNotesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectNotesQuery, ProjectNotesQueryVariables>(
    ProjectNotesDocument,
    options
  );
}
export type ProjectNotesQueryHookResult = ReturnType<
  typeof useProjectNotesQuery
>;
export type ProjectNotesLazyQueryHookResult = ReturnType<
  typeof useProjectNotesLazyQuery
>;
export type ProjectNotesSuspenseQueryHookResult = ReturnType<
  typeof useProjectNotesSuspenseQuery
>;
export type ProjectNotesQueryResult = Apollo.QueryResult<
  ProjectNotesQuery,
  ProjectNotesQueryVariables
>;
export const ProjectsDocument = gql`
  query Projects($filter: ProjectsFilter!) {
    projects(filter: $filter) {
      id
      name
      description
      candidates
      scorecard_id
      team_id
      client_name
      kanban_columns {
        people
        id
      }
      meta
      config
    }
  }
`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProjectsQuery(
  baseOptions: Apollo.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables> &
    ({ variables: ProjectsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  );
}
export function useProjectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProjectsQuery,
    ProjectsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  );
}
export function useProjectsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(
    ProjectsDocument,
    options
  );
}
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<
  typeof useProjectsLazyQuery
>;
export type ProjectsSuspenseQueryHookResult = ReturnType<
  typeof useProjectsSuspenseQuery
>;
export type ProjectsQueryResult = Apollo.QueryResult<
  ProjectsQuery,
  ProjectsQueryVariables
>;
